//
//
//
//
//
//

export default {
  name: "VocButton",
  props: {
    size: {
      type: String,
      default: "medium"
    }
  },
  methods: {
    onClick(evt) {
      this.$emit("voc-button-click", evt)
    }
  }
}
